let DataTimeUnit = /*#__PURE__*/function (DataTimeUnit) {
  DataTimeUnit["DAY"] = "day";
  return DataTimeUnit;
}({});

// need to be a type in order to be compatible with `[key: string]: string | number;` (BarDatum)

// need to be a type in order to be compatible with `[key: string]: string | number;` (BarDatum)

export { DataTimeUnit };
//# sourceMappingURL=UserAnalytics.js.map
